import { SortDirection } from '../../table/constants/sort-direction';

export interface ColumnDynamicProperties {
  /**
   * Максимальная ширина
   */
  maxWidth: number;

  /**
   * Порядок
   */
  orderIndex: number;

  /**
   * Уникальный идентификатор связанной колонки
   */
  uniqueId: string;

  /**
   * Направление сортировки по колонке
   */
  sortDirection: SortDirection;

  /**
   * Порядковый номер для сортировки
   */
  sortOrder: number;

  /**
   * Ширина колонки
   */
  width: number;
}
